import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { IssueTable } from '@/components/features/issues';

export function IssuesPage() {
  return (
    <>
      <Meta title="Issues" />

      <Container className="space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Problems with the portals themselves. Raised and tracked here.
        </p>
        <IssueTable />
      </Container>
    </>
  );
}
